import React from 'react';
function ArrowBack() {
    return (React.createElement("g", null,
        React.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
        React.createElement("path", { d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" })));
}
export default ArrowBack;
